import { useContext } from "react";
import { AbilityContext } from "@context/can";
import PropTypes from "prop-types";

const ActionWrapper = (props) => {
  const { child = <></>, subject, action } = props;
  const ability = useContext(AbilityContext);
  return subject ? (ability.can(action, subject) ? child : null) : child;
};

ActionWrapper.propTypes = {
  child  : PropTypes.any,
  subject: PropTypes.string.isRequired,
  action : PropTypes.string.isRequired
};

export default ActionWrapper;
